import { Card } from 'ui-components/components/card';
import { Divider } from 'ui-components/components/divider';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { useStoreUpdateContext } from '../../context';
import { messages } from '../messages';
import { SettingSection } from './components/setting-section/setting-section';
import style from './product-handling-card.module.less';

type ProductHandlingCardProps = {
  products: {
    createNewProducts: boolean;
    matchProductByName: boolean;
    createAdjustmentProducts: boolean;
  };
};

const OPTION_YES = 'yes';
const OPTION_NO = 'no';

const CREATE_NEW_PRODUCTS_OPTIONS = [
  { id: OPTION_YES, message: messages.yes },
  { id: OPTION_NO, message: messages.no },
];

const OPTION_SKU = 'sku';
const OPTION_NAME = 'name';

const MATCH_PRODUCT_OPTIONS = [
  { id: OPTION_SKU, message: messages.productSku },
  { id: OPTION_NAME, message: messages.productName },
];

const OPTION_INCLUDED = 'included';
const OPTION_NOT_INCLUDED = 'notIncluded';

const COUPON_OPTIONS = [
  { id: OPTION_INCLUDED, message: messages.couponsIncluded },
  { id: OPTION_NOT_INCLUDED, message: messages.couponsNotIncluded },
];

export const ProductHandlingCard = ({ products }: ProductHandlingCardProps) => {
  const { createNewProducts, matchProductByName, createAdjustmentProducts } = products ?? {};
  const { updateStoreSetting } = useStoreUpdateContext();

  const GROUP_NAME = 'products';

  return (
    <Card className={style['products-card']}>
      <FlexRow className={style['card-title']} gap={Gap.Space8}>
        <Text textType={TextType.H4} value={messages.productHandling} />
      </FlexRow>
      <div className={style['card-description']}>
        <Text textType={TextType.Caption} value={messages.productHandlingDescription} />
      </div>

      <SettingSection
        description={messages.createProductRecordsDescription}
        onOptionSelected={(option) => updateStoreSetting(GROUP_NAME, 'createNewProducts', option.id === OPTION_YES)}
        options={CREATE_NEW_PRODUCTS_OPTIONS}
        selectedId={createNewProducts ? OPTION_YES : OPTION_NO}
        title={messages.automaticallyCreateProductRecords}
      />

      <Divider className={style.divider} />

      <SettingSection
        description={messages.identifyProductsDescription}
        onOptionSelected={(option) => updateStoreSetting(GROUP_NAME, 'matchProductByName', option.id === OPTION_NAME)}
        options={MATCH_PRODUCT_OPTIONS}
        selectedId={matchProductByName ? OPTION_NAME : OPTION_SKU}
        title={messages.identifyProductsBy}
      />

      <Divider className={style.divider} />

      <SettingSection
        description={messages.handleCouponsDescription}
        onOptionSelected={(option) => updateStoreSetting(GROUP_NAME, 'createAdjustmentProducts', option.id === OPTION_NOT_INCLUDED)}
        options={COUPON_OPTIONS}
        selectedId={createAdjustmentProducts ? OPTION_NOT_INCLUDED : OPTION_INCLUDED}
        title={messages.handleCouponsAndDiscounts}
      />
    </Card>
  );
};
